import { Component, forwardRef, inject, ViewChild } from '@angular/core'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'
import {
  IonicSelectableCloseButtonTemplateDirective,
  IonicSelectableComponent,
  IonicSelectableItemTemplateDirective,
  IonicSelectableValueTemplateDirective,
} from 'ionic-selectable'
import { IonicModule } from '@ionic/angular'
import { BehaviorSubject, combineLatest, Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { searchFilter } from '../../../../services/utils'
import { AsyncPipe } from '@angular/common'
import { OaCoordinatorService } from '../../../../services/domain/keyCoordinator/oa-coordinator.service'
import { OaCoordinator } from '../../../../models/oaCoordinator'

@Component({
  selector: 'app-key-coordinator-select',
  templateUrl: './key-coordinator-select.component.html',
  styleUrls: ['./key-coordinator-select.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KeyCoordinatorSelectComponent),
      multi: true,
    },
  ],
  imports: [
    IonicSelectableComponent,
    IonicModule,
    AsyncPipe,
    FormsModule,
    IonicSelectableComponent,
    IonicSelectableValueTemplateDirective,
    IonicSelectableCloseButtonTemplateDirective,
    IonicSelectableItemTemplateDirective,
  ],
})
export class KeyCoordinatorSelectComponent implements ControlValueAccessor {
  private oaCoordinatorsService = inject(OaCoordinatorService)

  @ViewChild('selectableComponent')
  selectableComponent: IonicSelectableComponent

  private _value: number // keyCoordinatorId
  public disabled: boolean
  private _onChange: (value: number) => void
  protected _onTouched: () => void
  protected selectedItem: OaCoordinator

  protected onSearch$$: BehaviorSubject<string> = new BehaviorSubject('')
  private onWriteValue$$ = new BehaviorSubject<void>(null)

  protected filteredKeyCoordinators$: Observable<OaCoordinator[]> = combineLatest([
    this.oaCoordinatorsService.getAll(),
    this.onWriteValue$$,
  ]).pipe(
    switchMap(([keyCoordinators, _]) => {
      this.selectedItem = keyCoordinators.find((kc) => kc.userId === this._value)
      return this.onSearch$$.pipe(map((searchPhrase) => searchFilter(keyCoordinators, searchPhrase, ['fullname'])))
    }),
  )

  registerOnChange(fn: any): void {
    this._onChange = fn
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }
  writeValue(value: any): void {
    this._value = value
    this.onWriteValue$$.next()
  }

  searchKeyCoordinators(text: string) {
    this.onSearch$$.next(text)
  }

  itemSelected(event: { component: IonicSelectableComponent; value: OaCoordinator }) {
    this._value = event.value.userId
    this._onChange(this._value)
  }
}
